// extracted by mini-css-extract-plugin
module.exports = {"shp2-detail-K":"SHP2K_shp2-detail-K__J2gKK"};